(function() {
  'use strict';

  var GAS_WEB_APP_URL = 'https://script.google.com/macros/s/AKfycbxaTJqdAtAVtKbgEJblmxJATP4gSlsV2qd9ZkdtOxAV-yvmXnU6tgMnoKTDN-tEGPEo/exec';
  var STORAGE_DAYS = 30;
  var ITEMS_KEY = 'idetox/rfq/items';
  var ITEMS_SAVED_AT_KEY = 'idetox/rfq/items.savedAt';
  var CUSTOMER_KEY = 'idetox/rfq/customer';
  var CUSTOMER_SAVED_AT_KEY = 'idetox/rfq/customer.savedAt';
  var THANKS_URL = '/pages/quate_inquiry_thanks';
  var PUBLIC_ORIGIN = 'https://idetox.jp';

  var state = {
    modal: null,
    form: null,
    step: 1,
    items: [],
    currentProduct: null,
    requestType: '見積り',
    pageLoadTime: Date.now(),
    userInteracted: false,
    skipItemStep: false,
    // どこから開いたか（'cart' = カートの「この内容で見積もりを依頼する」）。GA4 の entry に載せる
    entry: ''
  };

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function isExpired(savedAt) {
    if (!savedAt) return false;
    var then = new Date(savedAt).getTime();
    if (!then) return true;
    return Date.now() - then > STORAGE_DAYS * 24 * 60 * 60 * 1000;
  }

  function readJson(key, fallback) {
    try {
      var raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function saveItems() {
    // カートから開いたリストはその場だけで持つ（商品ページで貯めた見積りリストを上書きしない）
    if (state.entry === 'cart') return;
    localStorage.setItem(ITEMS_KEY, JSON.stringify(state.items));
    localStorage.setItem(ITEMS_SAVED_AT_KEY, new Date().toISOString());
  }

  function loadItems() {
    if (isExpired(localStorage.getItem(ITEMS_SAVED_AT_KEY))) {
      clearItems();
      return [];
    }
    return readJson(ITEMS_KEY, []);
  }

  function clearItems() {
    localStorage.removeItem(ITEMS_KEY);
    localStorage.removeItem(ITEMS_SAVED_AT_KEY);
  }

  function saveCustomer() {
    if (!state.form) return;
    var data = getCustomerData();
    localStorage.setItem(CUSTOMER_KEY, JSON.stringify(data));
    localStorage.setItem(CUSTOMER_SAVED_AT_KEY, new Date().toISOString());
  }

  function loadCustomer() {
    if (isExpired(localStorage.getItem(CUSTOMER_SAVED_AT_KEY))) {
      clearCustomer();
      return {};
    }
    return readJson(CUSTOMER_KEY, {});
  }

  function clearCustomer() {
    localStorage.removeItem(CUSTOMER_KEY);
    localStorage.removeItem(CUSTOMER_SAVED_AT_KEY);
  }

  function formatMoney(value) {
    var amount = Number(value || 0);
    return new Intl.NumberFormat('ja-JP', {
      style: 'currency',
      currency: 'JPY',
      maximumFractionDigits: 0
    }).format(amount);
  }

  function normalizeImageUrl(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    if (url.indexOf('/cdn/') === 0 || url.indexOf('/files/') === 0) return PUBLIC_ORIGIN + url;
    if (url.charAt(0) === '/') return PUBLIC_ORIGIN + url;
    return url;
  }

  function productUrl(handle, variantId) {
    return PUBLIC_ORIGIN + '/products/' + handle + (variantId ? '?variant=' + variantId : '');
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getProductJson() {
    var script = qs('script[id^="ProductJson-"]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function getSelectedVariant(product) {
    if (!product) return null;
    var variantSelect = qs('select[name="id"]');
    var selectedId = variantSelect ? String(variantSelect.value) : '';
    var variants = product.variants || [];
    return variants.find(function(variant) {
      return String(variant.id) === selectedId;
    }) || variants.find(function(variant) {
      return variant.available;
    }) || variants[0] || null;
  }

  function getVariantImage(product, variant) {
    if (variant && variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }
    if (product && product.featured_image) {
      return product.featured_image;
    }
    if (product && product.images && product.images.length) {
      return product.images[0];
    }
    return '';
  }

  function getCurrentQuantity() {
    var input = qs('[data-quantity-input], input[name="quantity"]');
    var value = input ? parseInt(input.value, 10) : 1;
    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  function buildCurrentItem() {
    var product = getProductJson();
    var variant = getSelectedVariant(product);
    if (!product || !variant) return null;
    var options = variant.title && variant.title !== 'Default Title' ? variant.title : '';
    var productUrlValue = productUrl(product.handle, variant.id);
    var qty = getCurrentQuantity();
    var price = Math.round(Number(variant.price || 0) / 100);

    return {
      id: String(product.id) + '-' + String(variant.id) + '-' + options,
      productId: String(product.id),
      productHandle: product.handle,
      productName: product.title,
      vendor: product.vendor || 'idetox',
      variantId: String(variant.id),
      variantName: options,
      image: normalizeImageUrl(getVariantImage(product, variant)),
      productUrl: productUrlValue,
      qty: qty,
      price: price,
      options: options,
      addedAt: new Date().toISOString()
    };
  }

  function addCurrentItem() {
    var item = buildCurrentItem();
    if (!item) return;
    state.currentProduct = item;
    state.items = loadItems();
    var existing = state.items.find(function(existingItem) {
      return existingItem.id === item.id;
    });
    if (existing) {
      // 同じ商品で開き直しても数量を足さない（商品ページで選んだ数量にそろえる）
      existing.qty = Math.max(1, Number(item.qty || 1));
      existing.price = item.price;
      existing.productName = item.productName;
      existing.variantName = item.variantName;
      existing.image = item.image;
      existing.productUrl = item.productUrl;
      existing.options = item.options;
    } else {
      state.items.push(item);
    }
    saveItems();
  }

  // カートの中身を見積りの商品リストにする（カートの「この内容で見積もりを依頼する」）。
  // 「この内容で」なので、以前に商品ページから足したリストには混ぜずに置き換える
  function loadCartItems() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function(response) {
      if (!response.ok) throw new Error('cart fetch failed');
      return response.json();
    }).then(function(cart) {
      return (cart.items || []).map(function(line) {
        var options = line.variant_title && line.variant_title !== 'Default Title' ? line.variant_title : '';
        return {
          id: String(line.product_id) + '-' + String(line.variant_id) + '-' + options,
          productId: String(line.product_id),
          productHandle: line.handle,
          productName: line.product_title,
          vendor: line.vendor || 'idetox',
          variantId: String(line.variant_id),
          variantName: options,
          image: normalizeImageUrl(line.image || ''),
          productUrl: productUrl(line.handle, line.variant_id),
          qty: Number(line.quantity) || 1,
          price: Math.round(Number(line.price || 0) / 100),
          options: options,
          addedAt: new Date().toISOString()
        };
      });
    });
  }

  // GA4 のイベントに、どこから開いたか（entry）を、あるときだけ付ける
  function withEntry(params) {
    if (state.entry) params.entry = state.entry;
    return params;
  }

  function getInquiryItems() {
    var current = buildCurrentItem() || state.currentProduct;
    // カートページには「いま見ている商品」が無いので、カートの中身を問い合わせの対象にする
    if (!current) return state.entry === 'cart' ? state.items : [];
    return [Object.assign({}, current, { qty: 1 })];
  }

  function getActiveItems() {
    return state.requestType === '見積り' ? state.items : getInquiryItems();
  }

  async function refreshItemPrices() {
    var items = state.items.slice();
    await Promise.all(items.map(function(item) {
      if (!item.productHandle) return Promise.resolve();
      return fetch('/products/' + encodeURIComponent(item.productHandle) + '.js', {
        credentials: 'same-origin'
      }).then(function(response) {
        if (!response.ok) throw new Error('product fetch failed');
        return response.json();
      }).then(function(product) {
        var variant = (product.variants || []).find(function(v) {
          return String(v.id) === String(item.variantId);
        });
        if (!variant) return;
        item.productName = product.title || item.productName;
        item.vendor = product.vendor || item.vendor;
        item.variantName = variant.title && variant.title !== 'Default Title' ? variant.title : '';
        item.options = item.variantName;
        item.price = Math.round(Number(variant.price || 0) / 100);
        item.productUrl = productUrl(product.handle, variant.id);
        if (variant.featured_image && variant.featured_image.src) {
          item.image = normalizeImageUrl(variant.featured_image.src);
        } else if (product.featured_image) {
          item.image = normalizeImageUrl(product.featured_image);
        }
      }).catch(function() {});
    }));
    state.items = items;
    saveItems();
  }

  function renderItems(target, items, options) {
    var showQuoteControls = options && options.showQuoteControls;
    var readOnly = options && options.readOnly;
    var hideTotals = options && options.hideTotals; // 1画面目は取引感を減らすため金額列・小計を出さない
    if (!target) return;

    if (!items.length) {
      target.innerHTML = '';
      return;
    }

    // 読み取り専用（確認画面・相談）は表にせず、商品名＋数量の短い一覧にする（スマホで裸の数字が並ばない）
    if (readOnly) {
      target.innerHTML = '<ul class="rfq-modal__confirm-items">' + items.map(function(item) {
        return [
          '<li class="rfq-modal__item-product">',
          item.image ? '<img src="' + escapeHtml(item.image) + '" alt="">' : '',
          '<div>',
          '<div class="rfq-modal__item-name">' + escapeHtml(item.productName) + '</div>',
          '<div class="rfq-modal__item-variant">' + escapeHtml(item.variantName || item.options || '') + '</div>',
          state.requestType === '見積り' ? '<div class="rfq-modal__item-qty">数量：' + escapeHtml(item.qty) + '</div>' : '',
          '</div>',
          '</li>'
        ].join('');
      }).join('') + '</ul>';
      return;
    }

    var rows = items.map(function(item, index) {
      var lineTotal = Number(item.qty || 0) * Number(item.price || 0);
      return [
        '<tr data-rfq-item-index="' + index + '">',
        '<td>',
        '<div class="rfq-modal__item-product">',
        item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.productName) + '">' : '',
        '<div>',
        '<div class="rfq-modal__item-name">' + escapeHtml(item.productName) + '</div>',
        '<div class="rfq-modal__item-variant">' + escapeHtml(item.variantName || item.options || '') + '</div>',
        '</div>',
        '</div>',
        '</td>',
        showQuoteControls ? '<td><div class="rfq-modal__qty-row"><span class="rfq-modal__qty-label" aria-hidden="true">数量</span><input type="number" min="0" inputmode="numeric" value="' + escapeHtml(item.qty) + '" data-rfq-qty aria-label="数量"><button type="button" class="rfq-modal__delete" data-rfq-delete aria-label="この商品を外す">×</button></div></td>' : '',
        (showQuoteControls && !hideTotals) ? '<td>' + formatMoney(lineTotal) + '</td>' : '',
        readOnly && state.requestType === '見積り' ? '<td>' + escapeHtml(item.qty) + '</td><td>' + formatMoney(lineTotal) + '</td>' : '',
        '</tr>'
      ].join('');
    }).join('');

    var subtotal = items.reduce(function(total, item) {
      return total + Number(item.qty || 0) * Number(item.price || 0);
    }, 0);

    var tableHead = showQuoteControls || state.requestType === '見積り'
      ? (hideTotals
          ? '<thead><tr><th>製品</th><th>数量</th></tr></thead>'
          : '<thead><tr><th>製品</th><th>数量</th><th>合計</th></tr></thead>')
      : '<thead><tr><th>製品</th></tr></thead>';
    var subtotalHtml = (state.requestType === '見積り' && !hideTotals)
      ? '<div class="rfq-modal__subtotal">小計: ' + formatMoney(subtotal) + '</div>'
      : '';

    target.innerHTML = '<table class="rfq-modal__item-table">' + tableHead + '<tbody>' + rows + '</tbody></table>' + subtotalHtml;
  }

  function renderStep1() {
    state.requestType = getRequestType();
    var items = getActiveItems();
    var empty = qs('[data-rfq-empty]', state.modal);
    var target = qs('[data-rfq-items]', state.modal);
    if (empty) empty.hidden = items.length > 0;
    var tel = qs('[data-rfq-tel]', state.modal);
    if (tel) tel.hidden = !(state.requestType === '見積り' && items.length > 0);
    renderItems(target, items, {
      showQuoteControls: state.requestType === '見積り',
      readOnly: state.requestType !== '見積り',
      hideTotals: true // 1画面目は金額・小計を出さず「相談しやすさ」を優先
    });

    qsa('[data-rfq-qty]', target).forEach(function(input) {
      input.addEventListener('input', function() {
        var row = input.closest('[data-rfq-item-index]');
        var index = Number(row.dataset.rfqItemIndex);
        var qty = parseInt(input.value, 10);
        if (!Number.isFinite(qty)) return;
        if (qty <= 0) {
          state.items.splice(index, 1);
        } else if (state.items[index]) {
          state.items[index].qty = qty;
        }
        saveItems();
        renderStep1();
      });
    });

    qsa('[data-rfq-delete]', target).forEach(function(button) {
      button.addEventListener('click', function() {
        var row = button.closest('[data-rfq-item-index]');
        var index = Number(row.dataset.rfqItemIndex);
        state.items.splice(index, 1);
        saveItems();
        renderStep1();
      });
    });
  }

  function updateQuoteOnlyFields() {
    var isQuote = getRequestType() === '見積り';
    qsa('[data-rfq-quote-only]', state.modal).forEach(function(field) {
      field.hidden = !isQuote;
    });
    var messageMarker = qs('[data-rfq-message-required]', state.modal);
    if (messageMarker) messageMarker.hidden = isQuote;
    // ご要望欄: 見積りは任意の「ご質問・ご要望」、相談は必須の「ご相談内容」
    var optionalMarker = qs('[data-rfq-message-optional]', state.modal);
    if (optionalMarker) optionalMarker.hidden = !isQuote;
    var messageLabel = qs('[data-rfq-message-label]', state.modal);
    if (messageLabel) messageLabel.textContent = isQuote ? 'ご質問・ご要望' : 'ご相談内容';
    var messageInput = qs('[name="message"]', state.form);
    if (messageInput) {
      messageInput.placeholder = isQuote
        ? '設置場所・ご希望の時期など、あればご記入ください'
        : 'ご相談したい内容をご記入ください';
    }
  }

  function updateContactRequiredMarkers() {
    var preferred = getFieldValue('preferredContact');
    var emailMarker = qs('[data-rfq-email-required]', state.modal);
    var phoneMarker = qs('[data-rfq-phone-required]', state.modal);
    if (emailMarker) emailMarker.hidden = preferred !== 'メール';
    if (phoneMarker) phoneMarker.hidden = preferred !== 'お電話';
    // 選んだ連絡方法の欄だけ出す（項目を減らしてスクロールを避ける）
    var emailField = qs('[data-rfq-contact-email]', state.modal);
    var phoneField = qs('[data-rfq-contact-phone]', state.modal);
    if (emailField) emailField.hidden = preferred === 'お電話';
    if (phoneField) phoneField.hidden = preferred !== 'お電話';
  }

  function updateCompanyField() {
    // 会社名は「法人」を選んだときだけ表示（任意）
    var field = qs('[data-rfq-company-field]', state.modal);
    if (field) field.hidden = getFieldValue('customerType') !== '法人';
  }

  function updateRfqHighlights() {
    if (!state.form) return;
    updateCompanyField();
    var isQuote = getRequestType() === '見積り';
    var preferred = getFieldValue('preferredContact');
    var required = {
      customerType: true,
      lastName: true,
      firstName: true,
      preferredContact: true,
      email: preferred === 'メール',
      phone: preferred === 'お電話',
      message: !isQuote
    };
    Object.keys(required).forEach(function(name) {
      setRfqFieldHighlight(name, required[name]);
    });
  }

  function setRfqFieldHighlight(name, isRequired) {
    var field = state.form.elements[name];
    if (!field) return;
    var el = field instanceof RadioNodeList ? qsa('input[name="' + name + '"]', state.form)[0] : field;
    var group = el ? el.closest('.rfq-modal__field') : null;
    if (!group) return;
    var value = String(getFieldValue(name) || '').trim();
    group.classList.toggle('rfq-modal__field--required-empty', isRequired && !value);
  }

  function getFieldValue(name) {
    var field = state.form.elements[name];
    if (!field) return '';
    if (field instanceof RadioNodeList) {
      return field.value || '';
    }
    return field.value || '';
  }

  function setFieldValue(name, value) {
    var field = state.form.elements[name];
    if (!field || value == null) return;
    if (field instanceof RadioNodeList) {
      qsa('input[name="' + name + '"]', state.form).forEach(function(input) {
        input.checked = input.value === value;
      });
    } else {
      field.value = value;
    }
  }

  function getRequestType() {
    if (state.modal && state.modal.dataset.rfqInquiryOnly === 'true') return 'お問合せ';
    return getFieldValue('requestType') || '見積り';
  }

  function getCustomerData() {
    // 画面に出ていない欄の値は使わない（会社名は法人のときだけ・連絡先は選んだ方だけ）
    var preferred = getFieldValue('preferredContact') || 'メール';
    var isCorporate = getFieldValue('customerType') === '法人';
    return {
      requestType: getRequestType(),
      customerType: getFieldValue('customerType'),
      company: isCorporate ? getFieldValue('company').trim() : '',
      lastName: getFieldValue('lastName').trim(),
      firstName: getFieldValue('firstName').trim(),
      preferredContact: preferred,
      email: preferred === 'お電話' ? '' : getFieldValue('email').trim(),
      phone: preferred === 'お電話' ? getFieldValue('phone').trim() : '',
      purpose: getFieldValue('purpose'),
      deliveryTiming: getFieldValue('deliveryTiming').trim(),
      message: getFieldValue('message').trim(),
      installLocation: getFieldValue('installLocation').trim()
    };
  }

  function restoreCustomer() {
    var data = loadCustomer();
    Object.keys(data).forEach(function(key) {
      if (key === 'requestType') return;
      setFieldValue(key, data[key]);
    });
    updateContactRequiredMarkers();
    // 戻した会社名でも、同じ名前の会社を裏で調べておく（assets/company-candidates.js）
    var company = qs('[name="company"]', state.form);
    if (company) company.dispatchEvent(new Event('change'));
  }

  // 最終確認の画面で選んだ会社（assets/company-candidates.js）。法人で、選んだときと会社名が同じときだけ送る
  function getCompanyCandidate() {
    var field = qs('[name="companyCandidateLine"]', state.form);
    if (!field || !field.value || getFieldValue('customerType') !== '法人') return null;
    var company = getFieldValue('company').normalize('NFKC').replace(/\s+/g, ' ').trim();
    if (field.getAttribute('data-for') !== company) return null;
    return { line: field.value, place: field.getAttribute('data-place') || '' };
  }

  function applyInquiryOnlyMode() {
    if (!state.modal || state.modal.dataset.rfqInquiryOnly !== 'true') return;
    setFieldValue('requestType', 'お問合せ');
    var typeField = qs('.rfq-modal__field--type', state.modal);
    if (typeField) typeField.hidden = true;
  }

  function clearErrors() {
    qsa('.has-error', state.form).forEach(function(field) {
      field.classList.remove('has-error');
    });
    qsa('.rfq-modal__error-message', state.form).forEach(function(message) {
      message.remove();
    });
    qsa('[aria-invalid]', state.form).forEach(function(el) {
      el.removeAttribute('aria-invalid');
      el.removeAttribute('aria-describedby');
    });
    var submitError = qs('[data-rfq-submit-error]', state.modal);
    if (submitError) {
      submitError.hidden = true;
      submitError.textContent = '';
    }
  }

  function addError(name, message) {
    var field = state.form.elements[name];
    var element = field instanceof RadioNodeList ? qsa('input[name="' + name + '"]', state.form)[0] : field;
    var group = element ? element.closest('.rfq-modal__field') : null;
    if (!group) return;
    group.classList.add('has-error');
    var error = document.createElement('div');
    error.className = 'rfq-modal__error-message';
    error.id = 'rfq-error-' + name;
    error.textContent = message;
    group.appendChild(error);
    // 読み上げ用: 該当の入力（ボタン群なら radiogroup）にエラーを結び付ける
    var target = group.querySelector('[role="radiogroup"]') || element;
    if (target) {
      target.setAttribute('aria-invalid', 'true');
      target.setAttribute('aria-describedby', error.id);
    }

    // 計測: どの項目で検証が止まったか（項目別離脱の把握・観測用。1モーダル1項目1回）
    try {
      state._vfFired = state._vfFired || {};
      if (!state._vfFired[name] && typeof window.gtag === 'function') {
        state._vfFired[name] = true;
        var vfReason = (message && message.indexOf('必須') !== -1) ? 'required' : 'format';
        window.gtag('event', 'form_validation_fail', { form_id: 'rfq', field_name: name, reason: vfReason });
      }
    } catch (e) {}
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function isValidPhone(value) {
    return /^[0-9+\-() ]{8,20}$/.test(value);
  }

  function validateStep2() {
    clearErrors();
    var data = getCustomerData();
    var ok = true;
    var isQuote = data.requestType === '見積り';

    [
      ['customerType', data.customerType],
      ['lastName', data.lastName],
      ['firstName', data.firstName],
      ['preferredContact', data.preferredContact]
    ].forEach(function(pair) {
      if (!pair[1]) {
        addError(pair[0], '必須項目です');
        ok = false;
      }
    });

    if (data.preferredContact === 'メール' && !data.email) {
      addError('email', '必須項目です');
      ok = false;
    }
    if (data.preferredContact === 'お電話' && !data.phone) {
      addError('phone', '必須項目です');
      ok = false;
    }
    if (data.email && !isValidEmail(data.email)) {
      addError('email', '無効なメールアドレスです');
      ok = false;
    }
    if (data.phone && !isValidPhone(data.phone)) {
      addError('phone', '電話番号の形式が正しくありません');
      ok = false;
    }
    // ご要望・ご相談内容は3画面目で入力・検証する（validateStep3）

    if (!ok) focusFirstError();
    return ok;
  }

  // 3画面目: 相談（お問合せ）のときはご相談内容を必須にする
  function validateStep3() {
    clearErrors();
    var data = getCustomerData();
    if (data.requestType !== '見積り' && !data.message) {
      addError('message', 'ご相談内容をご記入ください');
      focusFirstError();
      return false;
    }
    return true;
  }

  function focusFirstError() {
    // 画面に出ている欄のうち最初のエラーへ（非表示の欄にはフォーカスしない）
    var first = qsa('.has-error input, .has-error select, .has-error textarea', state.form).filter(function(el) {
      return el.offsetParent !== null || (el.type === 'radio' && el.closest('.rfq-modal__field').offsetParent !== null);
    })[0];
    if (first) first.focus();
  }

  function renderConfirm() {
    var items = getActiveItems();
    renderItems(qs('[data-rfq-confirm-items]', state.modal), items, { readOnly: true });

    var data = getCustomerData();
    var isPhone = data.preferredContact === 'お電話';
    var fields = [
      ['ご希望の内容', data.requestType === '見積り' ? 'お見積り' : 'ご相談・ご質問'],
      ['お客様の区分', data.customerType],
      ['会社名', data.company],
      ['お名前', [data.lastName, data.firstName].filter(Boolean).join(' ')],
      ['ご連絡先', isPhone ? 'お電話：' + (data.phone || '') : 'メール：' + (data.email || '')]
    ].filter(function(pair) { return pair[1]; }); // 空欄の項目は確認画面に出さない

    // 1行に「項目｜内容」を並べる短い一覧（ご要望は同じ画面の入力欄なので載せない）
    qs('[data-rfq-confirm-customer]', state.modal).innerHTML = '<dl class="rfq-modal__summary">' + fields.map(function(pair) {
      return '<div class="rfq-modal__summary-row"><dt>' + escapeHtml(pair[0]) + '</dt><dd>' + escapeHtml(pair[1]) + '</dd></div>';
    }).join('') + '</dl>';

    // 同じ名前の会社が複数あるときだけ、所在地を選んでもらう（任意。assets/company-candidates.js）
    if (window.idetoxCompanyCandidates) {
      window.idetoxCompanyCandidates.renderConfirm(state.form, qs('[data-rfq-confirm-company]', state.modal));
    }
  }

  function setStep(step) {
    state.step = step;
    qsa('[data-rfq-panel]', state.modal).forEach(function(panel) {
      panel.hidden = Number(panel.dataset.rfqPanel) !== step;
    });
    qsa('[data-rfq-step-label]', state.modal).forEach(function(label) {
      if (Number(label.dataset.rfqStepLabel) === step) {
        label.setAttribute('data-active', 'true');
      } else {
        label.removeAttribute('data-active');
      }
    });

    var secondary = qs('[data-rfq-secondary]', state.modal);
    var primary = qs('[data-rfq-primary]', state.modal);
    if (step === 1) {
      secondary.textContent = state.entry === 'cart' ? '閉じる' : '他の商品を追加する';
      primary.textContent = 'お客様情報の入力へ';
      renderStep1();
    } else if (step === 2) {
      secondary.textContent = state.skipItemStep ? '閉じる' : '戻る';
      primary.textContent = '入力内容の確認へ';
      // 保存値の復元は開いた最初の1回だけ（戻る/進むで入力中の値を上書きしない）
      if (!state.customerRestored) {
        restoreCustomer();
        state.customerRestored = true;
      }
      updateQuoteOnlyFields();
      updateRfqHighlights();
    } else {
      secondary.textContent = '戻る';
      primary.textContent = getRequestType() === '見積り' ? 'お見積り情報を送信' : 'お問い合わせを送信';
      renderConfirm();
    }
  }

  function openModal(trigger, cartItems) {
    var requestedType = trigger && trigger.dataset ? trigger.dataset.rfqType : '';
    state.entry = cartItems ? 'cart' : '';
    if (cartItems) requestedType = '見積り';
    if (requestedType === '見積り' || requestedType === 'お問合せ') {
      setFieldValue('requestType', requestedType);
    }
    applyInquiryOnlyMode();
    if (cartItems) {
      state.items = cartItems;
    } else if (requestedType === 'お問合せ') {
      state.currentProduct = buildCurrentItem();
      state.items = loadItems();
    } else {
      // 直前にカートから開いていても、保存してある見積りリストから始める
      state.items = loadItems();
      addCurrentItem();
    }
    refreshItemPrices().then(function() {
      renderStep1();
    });
    clearErrors();
    state._vfFired = {}; // 検証失敗イベントの重複抑制をモーダルを開くたびに初期化
    state.customerRestored = false;
    state.modal.classList.add('is-open');
    state.modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('overflow-hidden');
    state.skipItemStep = getRequestType() === 'お問合せ';
    if (state.skipItemStep) {
      setStep(2);
    } else {
      setStep(1);
      var first = qs('input[name="requestType"]', state.modal);
      if (first) first.focus();
    }

    if (typeof gtag === 'function') {
      gtag('event', 'rfq_open', withEntry({
        event_category: 'contact',
        event_label: 'product_rfq_inquiry',
        request_type: getRequestType(),
        transport_type: 'beacon'
      }));
      if (state.skipItemStep) {
        gtag('event', 'rfq_step_2', withEntry({
          event_category: 'contact',
          event_label: 'product_rfq_inquiry',
          request_type: getRequestType(),
          transport_type: 'beacon'
        }));
      }
    }
  }

  function closeModal() {
    state.modal.classList.remove('is-open');
    state.modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('overflow-hidden');
  }

  function generateInquiryId() {
    var now = new Date();
    var date = now.getFullYear().toString() + ('0' + (now.getMonth() + 1)).slice(-2) + ('0' + now.getDate()).slice(-2);
    var random = Math.random().toString(36).slice(2, 7);
    return 'RFQ-' + date + '-' + random;
  }

  function appendInquiryIdToText(value, inquiryId) {
    var note = 'inquiry_id: ' + inquiryId;
    var currentValue = String(value || '').replace(/\s+$/g, '');
    if (currentValue.indexOf(note) !== -1) return currentValue;
    return currentValue ? currentValue + '\n\n' + note : note;
  }

  function getDeviceInfo() {
    var ua = navigator.userAgent;
    return {
      type: /iPhone|Android.*Mobile/.test(ua) ? 'mobile' : (/iPad|Android/.test(ua) ? 'tablet' : 'desktop'),
      screenWidth: window.innerWidth,
      browser: /Chrome\//.test(ua) ? 'Chrome' : (/Safari\//.test(ua) ? 'Safari' : (/Firefox\//.test(ua) ? 'Firefox' : 'unknown')),
      os: /Windows/.test(ua) ? 'Windows' : (/Mac OS X/.test(ua) ? 'macOS' : (/iPhone|iPad/.test(ua) ? 'iOS' : (/Android/.test(ua) ? 'Android' : 'unknown')))
    };
  }

  function buildPayload(inquiryId) {
    var data = getCustomerData();
    var companyCandidate = getCompanyCandidate();
    var message = state.entry === 'cart' && data.requestType === '見積り' ? (data.message ? data.message + '\n\n' : '') + '（カートの内容から見積りを依頼）' : data.message;
    if (companyCandidate) message = (message ? message + '\n' : '') + companyCandidate.line;
    var device = getDeviceInfo();
    var items = getActiveItems();
    var subtotal = items.reduce(function(total, item) {
      return total + Number(item.qty || 0) * Number(item.price || 0);
    }, 0);

    return {
      action: 'rfq_inquiry_submit',
      inquiry_id: inquiryId,
      timestamp: new Date().toISOString(),
      request_type: data.requestType,
      customer_type: data.customerType,
      company: data.company,
      last_name: data.lastName,
      first_name: data.firstName,
      name: (data.lastName + ' ' + data.firstName).trim(),
      contact_method: data.preferredContact,
      email: data.email,
      phone: data.phone,
      purpose: data.requestType === '見積り' ? data.purpose : '',
      delivery_timing: data.requestType === '見積り' ? data.deliveryTiming : '',
      install_location: data.requestType === '見積り' ? data.installLocation : '',
      message: appendInquiryIdToText(message, inquiryId),
      items: items,
      item_count: items.length,
      subtotal: subtotal,
      device_type: device.type,
      screen_width: device.screenWidth,
      browser: device.browser,
      os: device.os,
      elapsed_ms: Date.now() - state.pageLoadTime,
      user_interacted: state.userInteracted
    };
  }

  function botCheckFailed() {
    var honeypot = qs('input[name="website"]', state.form);
    if (honeypot && honeypot.value.trim()) return true;
    if (Date.now() - state.pageLoadTime < 1200) return true;
    if (!state.userInteracted) return true;
    if (getActiveItems().length > 20) return true;
    return false;
  }

  async function submitForm() {
    clearErrors();
    var primary = qs('[data-rfq-primary]', state.modal);
    var inquiryId = generateInquiryId();
    var payload = buildPayload(inquiryId);

    if (botCheckFailed()) {
      clearItems();
      clearCustomer();
      window.location.href = THANKS_URL;
      return;
    }

    primary.disabled = true;
    primary.setAttribute('loading', '');
    try {
      var response = await fetch(GAS_WEB_APP_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
        redirect: 'follow'
      });
      var result = { status: 'ok' };
      try {
        result = await response.json();
      } catch (e) {}
      if (result.status !== 'ok') {
        throw new Error(result.message || '送信に失敗しました');
      }
      if (window.idetoxAdsUserData) window.idetoxAdsUserData({ email: payload.email, phone: payload.phone });
      if (typeof gtag === 'function') {
        gtag('event', 'form_submit', withEntry({
          event_category: 'contact',
          event_label: 'product_rfq_inquiry',
          form_name: 'product_rfq_inquiry',
          form_id: 'RfqInquiryForm',
          request_type: payload.request_type,
          inquiry_id: inquiryId,
          transport_type: 'beacon'
        }));
      }
      try {
        if (window.idetoxTrackYahooConversion) {
          window.idetoxTrackYahooConversion({ key: 'product-rfq-inquiry-' + inquiryId });
        }
      } catch (e) {}
      // OpenAI広告（ChatGPT広告）コンバージョン計測 lead_created（送信成功時のみ）
      try {
        if (window.oaiq) {
          window.oaiq('measure', 'custom', { type: 'custom' }, { custom_event_name: 'idetox_contact_lead' });
        }
      } catch (e) {}
      clearItems();
      clearCustomer();
      window.setTimeout(function() {
        window.location.href = THANKS_URL;
      }, 500);
    } catch (error) {
      var submitError = qs('[data-rfq-submit-error]', state.modal);
      if (submitError) {
        submitError.textContent = '送信中にエラーが発生しました。しばらく時間をおいて再度お試しください。';
        submitError.hidden = false;
      }
      if (typeof gtag === 'function') {
        gtag('event', 'rfq_submit_error', withEntry({
          event_category: 'contact',
          event_label: 'product_rfq_inquiry',
          request_type: payload.request_type,
          inquiry_id: inquiryId,
          transport_type: 'beacon'
        }));
      }
    } finally {
      primary.disabled = false;
      primary.removeAttribute('loading');
    }
  }

  // カートの中身で開く。カートが空・読めないときは開かない。
  // saunaVariants（カートページのボタンが持つ）があれば、本体がまだカートにあるかを確かめる。
  // カートページは行を JS で消すのでボタンが残ることがあり、本体が無ければ再読み込みしてボタンを消す
  var openingFromCart = false;
  function openFromCart(saunaVariants) {
    if (openingFromCart) return Promise.resolve();
    openingFromCart = true;
    return loadCartItems().then(function(items) {
      if (saunaVariants && !items.some(function(item) { return saunaVariants.indexOf(item.variantId) !== -1; })) {
        window.location.reload();
        return;
      }
      if (items.length) openModal(null, items);
    }).catch(function() {}).then(function() {
      openingFromCart = false;
    });
  }

  function bindEvents() {
    document.addEventListener('click', function(event) {
      // カートの「この内容で見積もりを依頼する」。カートページではその場で開く（ほかのページでは /cart?rfq=cart へ移る）
      // 見積りを受け付けるページ（カートページ・サウナ本体の商品ページ）ではその場で開く。それ以外はリンクどおり移る
      var cartButton = event.target.closest('[data-rfq-cart]');
      if (cartButton) {
        if (state.modal.dataset.rfqCartPage === 'true' || state.modal.dataset.rfqInquiryOnly !== 'true') {
          event.preventDefault();
          // カートに入れた直後のポップアップを閉じる（global.js の全画面のもの／theme.js のもの）
          var popup = document.querySelector('.cart-popup-wrapper.cart-popup-fullscreen');
          if (popup) {
            popup.remove();
            document.body.style.overflow = '';
          }
          var dismiss = cartButton.closest('[data-cart-popup-wrapper]');
          dismiss = dismiss && dismiss.querySelector('[data-cart-popup-dismiss]');
          if (dismiss) dismiss.click();
          var variants = (cartButton.dataset.saunaVariants || '').split(',').filter(Boolean);
          openFromCart(variants.length ? variants : null);
        }
        return;
      }
      var openButton = event.target.closest('[data-rfq-open], .js-estimate-btn-inline, #pseudo_click_estimate_btn_sp, #pseudo_click_estimate_btn_pc');
      if (openButton) {
        event.preventDefault();
        openModal(openButton);
        return;
      }
      if (event.target.closest('[data-rfq-close]')) {
        event.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && state.modal.classList.contains('is-open')) {
        closeModal();
      }
    });

    ['keydown', 'click', 'touchstart', 'mousemove'].forEach(function(eventName) {
      document.addEventListener(eventName, function() {
        state.userInteracted = true;
      }, { once: true });
    });

    qsa('input[name="requestType"]', state.form).forEach(function(input) {
      input.addEventListener('change', function() {
        state.requestType = getRequestType();
        updateQuoteOnlyFields();
        updateRfqHighlights();
        renderStep1();
      });
    });

    qsa('[name="preferredContact"]', state.form).forEach(function(input) {
      input.addEventListener('change', function() {
        updateContactRequiredMarkers();
        updateRfqHighlights();
        saveCustomer();
      });
    });

    qsa('input, select, textarea', state.form).forEach(function(field) {
      if (field.name === 'requestType') return;
      field.addEventListener('blur', saveCustomer);
      field.addEventListener('input', updateRfqHighlights);
      field.addEventListener('change', updateRfqHighlights);
    });

    qs('[data-rfq-secondary]', state.modal).addEventListener('click', function() {
      if (state.step === 1 || (state.step === 2 && state.skipItemStep)) {
        closeModal();
      } else {
        setStep(state.step - 1);
      }
    });

    qs('[data-rfq-primary]', state.modal).addEventListener('click', function() {
      if (state.step === 1) {
        if (getActiveItems().length === 0) {
          var emptyEl = qs('[data-rfq-empty]', state.modal);
          if (emptyEl) emptyEl.hidden = false;
          var emptyError = qs('[data-rfq-submit-error]', state.modal);
          if (emptyError) {
            emptyError.textContent = '商品が選択されていません。商品ページから追加いただくか、「まずは相談したい」を選んでお進みください。';
            emptyError.hidden = false;
          }
          return;
        }
        setStep(2);
        if (typeof gtag === 'function') {
          gtag('event', 'rfq_step_2', withEntry({ event_category: 'contact', event_label: 'product_rfq_inquiry', request_type: getRequestType(), transport_type: 'beacon' }));
        }
      } else if (state.step === 2) {
        if (!validateStep2()) return;
        saveCustomer();
        setStep(3);
        if (typeof gtag === 'function') {
          gtag('event', 'rfq_step_3', withEntry({ event_category: 'contact', event_label: 'product_rfq_inquiry', request_type: getRequestType(), transport_type: 'beacon' }));
        }
      } else {
        if (!validateStep3()) return;
        submitForm();
      }
    });
  }

  function init() {
    state.modal = qs('[data-rfq-modal]');
    if (!state.modal) return;
    state.form = qs('[data-rfq-form]', state.modal);
    state.items = loadItems();
    THANKS_URL = state.modal.dataset.thanksUrl || THANKS_URL;
    applyInquiryOnlyMode();

    var honeypot = document.createElement('input');
    honeypot.type = 'text';
    honeypot.name = 'website';
    honeypot.tabIndex = -1;
    honeypot.autocomplete = 'off';
    honeypot.style.position = 'absolute';
    honeypot.style.left = '-9999px';
    honeypot.setAttribute('aria-hidden', 'true');
    state.form.appendChild(honeypot);

    updateContactRequiredMarkers();
    bindEvents();

    // /cart?rfq=cart で来たら、カートの中身で見積り依頼を開く。URL からは消す（再読み込みで開き直さない）
    if (state.modal.dataset.rfqCartPage === 'true' && /[?&]rfq=cart\b/.test(location.search)) {
      history.replaceState(null, '', location.pathname + location.hash);
      openFromCart();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
